import axios from 'axios';

import { apiBase } from './apiBase';

function extractCsvText(data: unknown): string {
  if (typeof data === 'string') return data;
  if (data && typeof (data as any).data === 'string') return (data as any).data;
  return '';
}

/** Daily / weekly / monthly chart data.
 *  from / to format: YYYYMMDD  (e.g. 20260218) */
export const getChartHtsData = (
  symbol: string,
  interval: string,
  from: string,
  to: string,
  token: string,
): Promise<string> =>
  axios
    .get(`${apiBase()}/chart/hts`, { params: { symbol, interval, from, to, token } })
    .then((res) => extractCsvText(res.data));

/** Intraday (1 / 5 / 15 / 60 min) chart data.
 *  from / to format: YYYYMMDDHHmm  (e.g. 202601010800) */
export const getChartMtsData = (
  symbol: string,
  interval: string,
  from: string,
  to: string,
  token: string,
): Promise<string> =>
  axios
    .get(`${apiBase()}/chart/mts`, { params: { symbol, interval, from, to, token } })
    .then((res) => extractCsvText(res.data));
